(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const apply = () => {
    root.querySelectorAll('h1,h2,h3,p,span,div').forEach(element => {
      const text = element.textContent.replace(/\s+/g, ' ').trim().replace(/[.!?]+$/, '').toLowerCase();
      if (text === 'find us in store') element.classList.add('gymrat-stockists-main-heading');
      if (text === 'gymrat jerky, closer to you') element.classList.add('gymrat-stockists-tagline');
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; apply(); });
  }).observe(root, { childList: true, subtree: true, characterData: true });
  apply();
})();